/* global require */

// TODO: yaa
// GREEDY : https://stackoverflow.com/questions/1103149/non-greedy-reluctant-regex-matching-in-sed
// Working: grep "require(.*)" -rl src/** -rl | xargs -i@ perl -pi -e 's|(require\(.*?\))|\1.default|'

export default {
  path: '/',
  getComponent(location, callback) {
    require.ensure([], (require) => {
      callback(null, require('components/App').default);
    });
  },
  getIndexRoute(location, callback) {
    require.ensure([], (require) => {
      callback(null, { component: require('pages/index/components/IndexPage').default });
    });
  },
  getChildRoutes(location, callback) {
    require.ensure([], (require) => {
      callback(null, [
        require('pages/index').default,
        // require('pages/page').default,
        // require('pages/content').default,
        // require('pages/forget').default,
        // require('pages/contact').default,
        // require('pages/guide/routes').default,
        // require('pages/destination/Explorer').default,
        // require('pages/destination/Editor').default,
        // require('pages/destination/Viewer').default,
        // require('pages/partner/Explorer').default,
        // require('pages/partner/Editor').default,
        // require('pages/partner/Viewer').default,
        // require('pages/partner/Doc').default,
        // require('pages/business/Explorer').default,
        // require('pages/business/Editor').default,
        // require('pages/business/Viewer').default,
        // require('pages/business/Changep').default,
        // require('pages/journal/Explorer').default,
        // require('pages/journal/Viewer').default,
        // require('pages/user/Explorer').default,
        // require('pages/user/Editor').default,
        // require('pages/user/Viewer').default,
        // require('pages/user/UserstayList').default,
        // require('pages/admin/ActivateDevice').default,
        // require('pages/admin/TranslationsList').default,
        // require('pages/ads/Explorer').default,
        // require('pages/ads/Editor').default,
        // require('pages/ads/Viewer').default,
        // require('pages/ads/ClicksList').default,
        // require('pages/contract/Explorer').default,
        // require('pages/contract/Editor').default,
        // require('pages/contract/Viewer').default,
        // require('pages/finance/Addcc').default,
        // require('pages/finance/Gopay').default,
        // require('pages/finance/Payresp').default,
        // require('pages/finance/Transactions').default,
        // require('pages/finance/Invoices').default,
        // require('pages/snode/Editor').default,
        // require('pages/snode/Explorer').default,
        // require('pages/poi/Explorer').default,
        // require('pages/rate/Explorer').default,
        // require('pages/files/Explorer').default,
        // require('pages/wifiprovider/Explorer').default,
        // require('pages/wifiprovider/Editor').default,
        require('mob/routes').default,
        // require('mob/front').default,
        // require('mob/list').default,
        // require('mob/buzpoi').default,
        // require('mob/tnode').default,
        // require('mob/osmap').default,
        // require('mob/preview-routes').default,
        require('report').default,
        // require('dashboard').default,
        // require('dashboard/components').default,
        // require('pages/tutorial').default,
        // require('pages/videotutorial').default,
        // require('pages/register').default,
        // require('pages/recovery').default,
        // require('tablet').default,
        require('login').default,
        require('register').default,
        // require('register/key-confirm').default,
        require('register/invitation-confirm').default,
        require('register/forget-password').default,
        require('adv-landing').default,
        require('cp-landing').default,
        // require('test').default,
        require('salesmanager').default,
      ]);
    });
  },
};
